import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-5Y295NQ57X";

export default function RouteTracker() {
    const location = useLocation();
    useEffect(() => {
        if (typeof window === "undefined" || typeof window.gtag !== "function") return;
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            send_to: GA_ID,
        });
    }, [location.pathname, location.search]);
    return null;
}
